import { render, staticRenderFns } from "./DocumentArchiveIndicator.vue?vue&type=template&id=d35187a8&scoped=true&"
import script from "./DocumentArchiveIndicator.vue?vue&type=script&lang=ts&"
export * from "./DocumentArchiveIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentArchiveIndicator.vue?vue&type=style&index=0&id=d35187a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35187a8",
  null
  
)

export default component.exports